module.exports = __webpack_public_path__ + "static/media/10.fb96aab5.jpg";